import React from "react";
import { Link } from "react-router-dom";
import { FULLSTORY_ELEMENTS } from "utils/fullstoryElements";
import { FINAL_CTA } from "../../landingContent";

const FinalCtaSection = () => (
  <section className="landing-v2__section landing-v2-final-cta" aria-labelledby="final-cta-heading">
    <div className="landing-v2__container">
      <div className="landing-v2-final-cta__panel">
        <h2 id="final-cta-heading" className="landing-v2__heading landing-v2__heading--center">
          {FINAL_CTA.headline}
        </h2>

        <p className="landing-v2__subtext">{FINAL_CTA.subtext}</p>

        <div className="landing-v2__cta-row landing-v2__cta-row--center landing-v2-final-cta__actions">
          <Link
            to="/auth/register"
            className="landing-v2__btn landing-v2__btn--primary landing-v2__btn--full-mobile"
            data-fs-element={FULLSTORY_ELEMENTS.landing.finalTrial}
          >
            <i className="fa fa-rocket landing-v2__btn-icon" aria-hidden="true" />
            {FINAL_CTA.primaryCta}
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default FinalCtaSection;
